/**
 * Subtle, lightly-aspirational greetings for the empty-canvas landing screen.
 * One is chosen at random per mount (i.e. on open / refresh) and shown statically
 * in the menu-bar-style header above the composer — it does not rotate on screen.
 */

export const CANVAS_GREETINGS: string[] = [
  "A fresh canvas awaits.",
  "Let's make something.",
  "Where ideas take shape.",
  "Start anywhere.",
  "Think out loud.",
  "Bring an idea to life.",
  "A space to figure things out.",
];

/** Pick a greeting at random. Stable for the lifetime of a single mount. */
export function pickCanvasGreeting(): string {
  const i = Math.floor(Math.random() * CANVAS_GREETINGS.length);
  return CANVAS_GREETINGS[i];
}

/** Menu-bar date/time label, e.g. "Sat, Jun 7 · 2:34 PM". */
export function formatCanvasGreetingDate(date: Date): string {
  const day = date.toLocaleDateString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
  const time = date.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });
  return `${day} · ${time}`;
}
